module.exports = __webpack_public_path__ + "img/gabarito-5.7aff09d6.png";